<div class="claim-detail-sec"  [ngClass]="{'ma-claim-detail-sec': !isAcmic}">
  <div class="claim-item">
    <div class="claim-number">
      <ng-container
        *ngIf="claim?.propertyOrAutoIndicator === 'AUTO'; else homeLogo"
      >        
        <ng-container *ngIf="isAcmic; else maCarIcon">
          <img src="./assets/img/images/icon-car-24.svg" alt="car icon" />
        </ng-container>
        <ng-template #maCarIcon>
          <img src="./assets/img/images/icon-car.svg" alt="car icon" />
        </ng-template> 
      </ng-container>
      <ng-template #homeLogo>
        <ng-container *ngIf="isAcmic; else maHomeIcon">
          <img src="./assets/img/images/icon-home-24.svg" alt="home icon" />
        </ng-container>
        <ng-template #maHomeIcon>
          <ng-container *ngIf="claim?.propertyOrAutoIndicator === 'HOME'; else otherPolicyIcon">
            <img src="./assets/img/images/icon-home.svg" alt="home icon" />
          </ng-container>
          <ng-template #otherPolicyIcon>
            <div class="{{ claim?.propertyOrAutoIndicator | lowercase }}-class paperless-bg margin-right mr8 width-40 height-40"
              *ngIf="claim?.propertyOrAutoIndicator!=='AUTO' && claim?.propertyOrAutoIndicator !== 'HOME' "></div>
          </ng-template>
        </ng-template> 
      </ng-template>
      <div class="claims-font" [ngClass]="{'ml-0': isAcmic}">
        {{ exposure?.coverage?.code }}<span *ngIf="!isAcmic && claim?.policyNumber?.policyNumber?.length !== 10 && company !== 'TW'"> - {{ claim?.number?.number }}</span>
      </div>
    </div>
    <div class="claim-info" [ngClass]="{'margin-left ml16 no-margin-top': !isAcmic}">
      <div class="claim-info-left">
        <div class="claim-infor-color">{{ "Claim - " }} <ng-container *ngIf="claim?.policyNumber?.policyNumber?.length === 10 || company === 'TW'">{{ claim?.number?.number }}</ng-container><span *ngIf="!isAcmic && claim?.policyNumber?.policyNumber?.length !== 10 && company !== 'TW'"> {{ exposureNumber }}</span></div>
        <div class="policy-id margin-bottom mb4 claim-infor-color">
           <ng-container>
              <ng-container *ngIf="claim?.propertyOrAutoIndicator === 'AUTO' || claim?.propertyOrAutoIndicator === 'COMMERCIAL_AUTO' || claim?.propertyOrAutoIndicator === 'GARAGE_KEEPER' ||  claim?.propertyOrAutoIndicator === 'HOME' ">Personal</ng-container>
              {{claim?.propertyOrAutoIndicator === 'AUTO' || claim?.propertyOrAutoIndicator === 'COMMERCIAL_AUTO' || claim?.propertyOrAutoIndicator === 'GARAGE_KEEPER' ? 'auto' : claim?.propertyOrAutoIndicator === 'HOME' ? 'property' : claim?.propertyOrAutoIndicator | translate | titlecase }} - {{ claim?.policyNumber?.policyNumber }}
            </ng-container>
        </div>
        <div class="date-loss">
          <span> {{ "Date of loss" | translate }}</span>
          {{ claim?.date | date: "MM/dd/yyyy" }}
        </div>
      </div>
    </div>
  </div>
</div>
<div class="claim-detail-exposures claim-detail-sections ma-claim-detail-exposures">
  <section class="claim-details-left"  [ngClass]="company === 'TW' ? 'claim-detail-tw': null">
    <div class="exposures-content no-exposures">
      <div class="exposures-title mb-3" [ngClass]="{'dm-sans-medium': !isAcmic}">
        {{ "Information" | translate }}
      </div>
      <div class="no-exposures-info">
        <div class="claim-location mb-3">
          <div class="claim-info-label">
            {{ "Claimant" }}
          </div>
          <div class="claim-info-value">
            {{ exposure?.claimant?.name | titlecase }}
          </div>
        </div>
        <div class="claim-location mb-3">
          <div class="claim-info-label">
            {{ "Location" }}
          </div>
          <div class="claim-info-value">
            <span *ngIf="exposure?.address?.streetName !== ''">
              {{ exposure?.address?.streetName | titlecase }},
            </span>
            <ng-container *ngIf="exposure?.address?.city">
              {{ exposure?.address?.city | titlecase }},
            </ng-container>
            {{ exposure?.address?.state }}
          </div>
        </div>
        <div class="claim-desc mb-3">
          <div class="claim-info-label">
            {{ "Description" }}
          </div>
          <div class="claim-info-value">
            {{ claim?.lossCause | titlecase }}
          </div>
        </div>
        <div class="claim-adjuster">
          <div class="claim-info-label mb-1">
            {{ "Adjuster" }}
          </div>
          <div class="adjuster-details">
            <div
              class="claim-info-value mb-2"
              *ngIf="exposure?.adjuster?.name !== ''"
            >
              {{ exposure?.adjuster?.name | titlecase }}
            </div>
            <div class="claim-info-value mb-2" *ngIf="!isAcmic">
              <div class="adjuster-infor">
                <div class="adjuster-info-title">{{ "EMAIL" | translate }}:</div>
                <div class="adjuster-info-val"><a href="mailto:{{ exposure?.adjuster?.email?.address }}"
                    class="mapfre link underline red-link">{{ exposure?.adjuster?.email?.address | lowercase }}</a>
                </div>
              </div>
            </div>
            <div class="claim-info-value mb-2">
              <div class="adjuster-infor">
                <div class="adjuster-info-title">{{ "PHONE" | translate }}:</div>
                <div class="adjuster-info-val"><a href="tel:{{
                                  exposure?.adjuster?.phoneNumber?.number | viewableExtension
                                }}" class="mapfre link underline red-link">{{
                                  exposure?.adjuster?.phoneNumber?.number | viewableExtension
                                }}</a>
                </div>
              </div>
            </div>
            <div
              class="claim-info-value"
              *ngIf="exposure?.adjuster?.extensionAndFax && !isAcmic"
            >
              <div class="adjuster-infor">
                <div class="adjuster-info-title">{{ "FAX" | translate | titlecase }}:</div>
                <div class="adjuster-info-val"><a href="tel:{{
                                  exposure?.adjuster?.extensionAndFax | usableFaxWithExtension
                                }}" class="mapfre link underline red-link">{{ exposure?.adjuster?.extensionAndFax }}</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ng-container
        *ngIf="
          exposure?.coverage?.code !== 'Part 10 - Substitute Transportation' &&
          exposure?.coverage?.code !== 'Part 11 - Towing and Labor' &&
          exposure?.coverage?.code !== 'Rental Reimbursement' &&
          exposure?.coverage?.code !== 'Rental' &&
          exposure?.coverage?.code !== 'Loss Of Use' &&
          exposure?.coverage?.code !== 'Towing'
        "
      >
        <ng-container
          *ngIf="
            (!exposure?.appraisals?.length || !exposure?.appraisals) &&
            !exposure?.payments?.length &&
            exposure?.displayToInsured !== 'L' && exposure?.propertyOrAutoIndicator !== 'COMMERCIAL_AUTO' && exposure?.propertyOrAutoIndicator !== 'GARAGE_KEEPER'
          "
        >
          <div class="exposures-title" [ngClass]="{'dm-sans-medium': !isAcmic}">
            {{ "Appraisal" | translate }}
          </div>
          <div class="no-exposures-info appraisal-text mt-4" *ngIf="exposure?.propertyOrAutoIndicator === 'AUTO'">
            {{
              "A licensed appraiser will be assigned to view your vehicle and write an appraisal for any accident related damage. Typically, the appraisal is received within 5 business days from the day the vehicle is seen by an appraiser. It is mailed to both you and your claim adjuster. Your claim adjuster will receive the copy of appraisal on or about the same day as you."
            }}
          </div>
          <div class="no-exposures-info appraisal-text mt-4" *ngIf="exposure?.propertyOrAutoIndicator === 'HOME'">
            {{
              "A licensed adjuster will be assigned to view your property and write an estimate for any accident related damage. Typically, the estimate is received within 5 business days from the day the property is seen by a licensed adjuster. This estimate will be mailed to you once it is completed."
            }}
          </div>
        </ng-container>
        <ng-container *ngIf="exposure?.appraisals?.length">
          <div class="exposure-sec-title" [ngClass]="{'dm-sans-medium': !isAcmic}">
            {{ "Appraisal" | translate }}
          </div>
          <div class="no-exposures-info">
            <table class="table sclaimsTbl claims-table">
              <thead class="lite-grey-color">
                <tr class="row-content border-full grey-border ">
                  <td class="fw-300">
                    {{ "NUMBER" | translate }}
                  </td>
                  <td class="fw-300">
                    {{ "APPRAISER" | translate }}
                  </td>
                  <td class="fw-300">
                    {{ "AMOUNT" | translate }}
                  </td>
                  <td class="fw-300">
                    {{ "STATUS" | translate }}
                  </td>
                </tr>
              </thead>
              <tbody class="fake-black-color">
                <tr
                  class="row-content border-full grey-border"
                  *ngFor="let appraisal of exposure?.appraisals"
                >
                  <td class="fw-300">
                    {{ appraisal?.number?.number
                    }}{{
                      appraisal?.supplementNumber
                        ? "-" + appraisal?.supplementNumber
                        : ""
                    }}
                  </td>
                  <td class="fw-300">
                    {{
                      appraisal?.appraiser?.name &&
                      appraisal?.appraiser?.name !== ""
                        ? appraisal?.appraiser?.name
                        : "N/A" | titlecase
                    }}
                  </td>
                  <td class="fw-300">
                    {{
                      appraisal?.totalLossIndicator &&
                      appraisal?.totalLossIndicator === true
                        ? "Total Loss"
                        : appraisal?.appraisalAmount &&
                          appraisal?.appraisalAmount !== ""
                        ? "$" + appraisal?.appraisalAmount
                        : "N/A"
                    }}
                  </td>
                  <td class="fw-300">
                    {{ appraisal?.status | titlecase }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </ng-container>
      </ng-container>
      <ng-container *ngIf="exposure?.payments?.length">
        <div class="exposure-sec-title" [ngClass]="{'dm-sans-medium': !isAcmic}">
          {{ "Payments" | translate }}
        </div>
        <div class="no-exposures-info">
          <div class="total-payments">
            <div class="claim-info-label">
              {{ "Total payments" }}
            </div>
            <div class="claim-info-value">
              {{ paymentToDate | currency }}
            </div>
          </div>
        </div>
        <div class="no-exposures-info">
          <table class="table sclaimsTbl claims-table">
            <thead class="lite-grey-color">
              <tr>
                <td
                  style="text-align: left !important;"
                  class="payee"
                  colspan="4"
                >
                  <div class="d-flex">
                    <div class="payTitleIEOnly">Payee: &nbsp;</div>
                    <strong class="payIEOnly">{{ payee }}</strong>
                  </div>
                </td>
              </tr>
              <tr class="row-content  border-full grey-border">
                <td>
                  {{ "DATE_PAID" | translate }}
                </td>
                <td>
                  {{ "CHECK" | translate }}
                </td>
                <td>
                  {{ "AMOUNT" | translate }}
                </td>
                <td>
                  {{ "STATUS" | translate }}
                </td>
              </tr>
            </thead>
            <tbody class="fake-black-color">
              <ng-container *ngFor="let payment of exposure?.payments">
              
                <tr class="row-content border-full grey-border">
                  <td>
                    <ng-container *ngIf="payment?.status?.date !== null">
                      {{ payment?.status?.date | date: "shortDate" }}
                    </ng-container>
                    <ng-container *ngIf="payment?.status?.date === null">
                      -
                    </ng-container>
                    
                  </td>
                  <td>
                    {{ payment?.checkNumber }}                    
                  </td>
                  <td>
                    {{ payment?.checkAmount | currency }}
                  </td>
                  <td>
                    {{ payment?.status?.code | titlecase }}
                  </td>
                </tr>
              </ng-container>
            </tbody>
          </table>
        </div>
      </ng-container>
    </div>
  </section>
  <!-- sidebar  -->
  <section *ngIf="company !== 'TW'"  class="claim-details-right">
    <div class="row claims-faq mb-4" *ngIf="isAcmic">
      <div class="col">
        <app-upload-documents-sidebar [claimId]="claimid"></app-upload-documents-sidebar>
      </div>
    </div>
    <div class="row claims-faq mb-4" *ngIf="!isAcmic">
      <div class="col">
        <app-claims-need-help></app-claims-need-help>
      </div>
    </div>
  </section>
</div>
<div class="row margin-top mt24 text-center checkingrowbtm">
  <div class="col">
    <mapfre-button
      additionalClasses="link-button small red-link no-margin button-border-red"
      [backIcon]="'assets/img/icons/back-arrow-red.png'"
      [iconClasses]="'align-middle'"
      [showIconsCustom]="true"
      [routerLink]="['/claims/' + claimid + '/details']"
    >
      {{ "BACK" | translate }}
    </mapfre-button>
  </div>
</div>
